export interface Voucher {
  _id: string;
  ativo: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  tipo: VoucherTypesEnum;
  tipo_desconto: VoucherDiscountTypesEnum;
  codigo: string;
  cep: string;
  regiao_tipo: string;
  descricao_regiao: string;
  descricao: string;
  limite_ativacoes_geral: number;
  recurso: number;
  valor_desconto: number;
  recurso_abatido: number;
  expirationDate: string;
  estabelecimentos: VoucherStores[];
  condominio: Condominium;
  consumo_geral: number;
  num_ativacoes_geral: number;
  clientes: string[];
}

export enum VoucherTypesEnum {
  REGIONAL = "regional",
  SELECTED = "selecionado",
  CONDOMINIUM = "condominio",
}

export enum VoucherDiscountTypesEnum {
  SHIPMENT_DISCOUNT = "frete",
  SHIPMENT_FREEE = "frete_gratis",
  DISCOUNT = "desconto",
}

interface VoucherStores {
  estabelecimento: string;
  num_ativacoes: number;
  limite_ativacoes: number;
  valor_minimo_pedido: number;
  consumo_estabelecimento: number;
}

interface Condominium {
  nome_condominio: string;
  endereco: string;
  cidade: string;
  tipo_horario: string;
  dias_promocao: PromoDays[];
}

interface PromoDays {
  dia_promocao: number;
  horarios_dia: string[];
}
